import React, { useState, useMemo } from "react";import Modal from '../modals/modal';
import LoadingView from '../loading/loading.view';
import './modalIndicadores.css';
import { ErpConnect as qad } from '../../../services';
import AsyncSelect from 'react-select/async';
import {  Row, Col } from 'react-materialize';
import Swal from 'sweetalert2';
import axios from "axios";

function buildTerritoryIndex(rows = []) {
  const sellerToTerritory = {};
  const territoryToSellers = {};
  const territories = [];
  const seen = new Set();

  rows.forEach((r) => {
    const sp = norm(r.salesPersonId || r.sales_person_id || r.slspsn || r.sellerId);
    const terrId = norm(r.id || r.territoryId || r.territory || r.terrId);
    const terrName = (r.name || r.territoryName || r.territory || terrId || "").toString().trim();
    if (terrId && !seen.has(terrId)) {
      territories.push({ value: terrId, label: terrName });
      seen.add(terrId);
    }

    if (!sp || !terrId) return;

    sellerToTerritory[sp] = terrId;

    if (!territoryToSellers[terrId]) territoryToSellers[terrId] = [];
    if (!territoryToSellers[terrId].includes(sp)) territoryToSellers[terrId].push(sp);
  });

  territories.sort((a, b) => a.label.localeCompare(b.label, "es"));
  return { sellerToTerritory, territoryToSellers, territories };
}

const daysInMonth = (year, monthIndex) =>
  new Date(year, monthIndex + 1, 0).getDate();
function getPotentialFactorFromState(state) {
  const { selectedWeek, selectedMonth, dateSelect, dateEndSelect } = state;
  if (selectedWeek) return 1;
  if (selectedMonth && dateSelect instanceof Date && dateEndSelect instanceof Date) {
    const start = dateSelect;
    const end = dateEndSelect;

    const sameMonth = start.getFullYear() === end.getFullYear() &&
                      start.getMonth() === end.getMonth();

    if (sameMonth) {
      const y = start.getFullYear();
      const m = start.getMonth();
      const dim = daysInMonth(y, m);
      const daysSelected = Math.floor((end - start) / (1000*60*60*24)) + 1;
      return Math.min(daysSelected / dim, 1);
    }
    return 1;
  }
  if (dateSelect instanceof Date && dateEndSelect instanceof Date) {
    const start = dateSelect;
    const end = dateEndSelect;

    const sameMonth = start.getFullYear() === end.getFullYear() &&
                      start.getMonth() === end.getMonth();

    if (sameMonth) {
      const y = start.getFullYear();
      const m = start.getMonth();
      const dim = daysInMonth(y, m);
      const daysSelected = Math.floor((end - start) / (1000*60*60*24)) + 1;
      return Math.min(daysSelected / dim, 1);
    }
    return 1;
  }
  return 1;
}

const CUSTOMERS_CACHE_KEY = "kpi_customers_cache_v1";
const CUSTOMERS_CACHE_TTL_MS = 1000 * 60 * 60 * 12; 

const TERR_CACHE_KEY = "kpi_territories_cache_v1";
const TERR_CACHE_TTL_MS = 1000 * 60 * 60 * 12;

function extractTerritoriesArray(resp) {
  if (!resp) return [];
  const raw =
    resp?.data?.read?.[0]?.data ??
    resp?.data?.data ??
    resp?.data?.territories ??
    resp?.data ??
    resp;

  return Array.isArray(raw) ? raw : [];
}

function norm(v) {
  return (v || "").toString().trim().toUpperCase();
}
function getSellerDepartmentId(seller) {
  return String(
    seller?.departmentId ??
    seller?.department_id ??
    seller?.deptId ??
    seller?.dept_id ??
    ""
  ).trim();
}

function isAdminLikeDepartment(dep) {
  const d = String(dep || "").trim();
  return d === "001" || d === "002" || d === "008";
}

function filterSellersForUser(data = [], user) {
  const dep = String(user?.departmentId || "").trim();

  if (dep === "001" || dep === "002") return Array.isArray(data) ? data : [];

  if (dep === "008") {
    return Array.isArray(data)
      ? data.filter((s) => getSellerDepartmentId(s) === "005")
      : [];
  }
  const sp = String(user?.salesPersonId || "").trim().toUpperCase();
  return Array.isArray(data) ? data.filter((s) => s.salesPersonId === sp) : [];
}


const TYPE_NAME_MAP = {
  TC0001: "BORDADOR",
  TC0002: "IMPRESOR",
  TC0004: "COMERCIALIZADOR",
  TC0003: "PROMOCIONAL",
  TC0005: "TEXTILES (UNIFORMES)",
  TC0006: "USO PERSONAL",
};

const DEFAULT_LINE_PRODUCTS = [
  { Id: "01", Name: "C/R", order: 11 },
  { Id: "02", Name: "CAMISAS", order: 7 },
  { Id: "03", Name: "CHM", order: 9999 },
  { Id: "04", Name: "CUELLO V", order: 9999 },
  { Id: "05", Name: "GORRAS", order: 9999 },
  { Id: "06", Name: "JACQUES", order: 9999 },
  { Id: "07", Name: "MADEIRA", order: 9999 },
  { Id: "08", Name: "MODIZ", order: 9999 },
  { Id: "09", Name: "MORRALES", order: 9999 },
  { Id: "10", Name: "OPTIMA", order: 9999 },
  { Id: "11", Name: "P/POLO", order: 9999 },
  { Id: "12", Name: "PELLON", order: 9999 },
  { Id: "13", Name: "PORTALATAS", order: 9999 },
  { Id: "14", Name: "PROTRIM  CR", order: 9999 },
  { Id: "15", Name: "PROTRIM  M.L.", order: 9999 },
  { Id: "16", Name: "PROTRIM  POLO", order: 9999 },
  { Id: "17", Name: "PROTRIM  SUD", order: 9999 },
  { Id: "18", Name: "SUDADERA", order: 9999 },
  { Id: "19", Name: "TERMOS", order: 9999 },
  { Id: "20", Name: "TOALLA", order: 9999 },
  { Id: "99", Name: "SIN AGRUPAR", order: 9999 },
];


function safeJsonParse(s, fallback) {
  try { return JSON.parse(s); } catch { return fallback; }
}



function makeZeroLineProducts() {
  return DEFAULT_LINE_PRODUCTS.map((lp) => ({
    ...lp,
    salesAmount: 0,
    salesQuantity: 0,
  }));
}
function normName(v) {
  return (v || "").toString().trim().toUpperCase();
}

function normalizeLineProducts(lineProducts) {
  const base = makeZeroLineProducts();
  const idx = new Map(base.map((lp, i) => [normName(lp.Name), i]));

  const extra = [];
  const arr = Array.isArray(lineProducts) ? lineProducts : [];

  arr.forEach((lp) => {
    const name = (lp?.Name || lp?.name || "").toString().trim();
    if (!name) return;

    const key = normName(name);
    const amount = Number(lp?.salesAmount || 0);
    const qty = Number(lp?.salesQuantity || 0);
    const ord = Number.isFinite(lp?.order) ? lp.order : 9999;

    if (idx.has(key)) {
      const i = idx.get(key);
      base[i] = {
        ...base[i],
        salesAmount: amount,
        salesQuantity: qty,
        order: Number.isFinite(ord) ? ord : base[i].order,
      };
    } else {
      extra.push({
        Id: lp?.Id || lp?.id || "",
        Name: name,
        order: ord,
        salesAmount: amount,
        salesQuantity: qty,
      });
    }
  });

  const merged = [...base, ...extra];

  merged.sort(
    (a, b) =>
      (Number(a.order ?? 9999) - Number(b.order ?? 9999)) ||
      String(a.Name || "").localeCompare(String(b.Name || ""), "es")
  );

  return merged;
}

function slimCustomer(c) {
  return {
    id: c?.id || "",
    name: c?.name || "",
    distributionChannel: c?.distributionChannel || "",
    territory: (c?.territory || c?.territoryId || "").toString().trim(), 
    customerType: c?.customerType || null,
    lastVisitDate: c?.lastVisitDate || null,
    potential: Number(c?.potential || 0),
    percentaje: Number(c?.percentaje || 0),
  };
}


function buildCustomersBySellerWithTerritory(customers = [], territoryToSellers = {}) {
  const map = {};
  const seen = {};

  const add = (sellerId, c) => {
    const s = norm(sellerId);
    const customerId = norm(c.id);
    if (!s || !customerId) return;

    if (!map[s]) map[s] = [];
    if (!seen[s]) seen[s] = new Set();
    if (seen[s].has(customerId)) return;

    seen[s].add(customerId);

    const typeId = c.customerType || null;

    map[s].push({
      customerId,
      customerName: (c.name || "").toString().trim(),
      territory: c.territory || "",
      typeId,
      typeName: typeId ? (TYPE_NAME_MAP[typeId] || null) : null,
      lastVisitDate: c.lastVisitDate || null,
      potential: Number(c.potential || 0),
      percentaje: Number(c.percentaje || 0),
    });
  };

  customers.forEach((c) => {
    const terr = norm(c.territory);
    const sellers = terr ? territoryToSellers[terr] : null;
    if (Array.isArray(sellers) && sellers.length) {
      sellers.forEach((sid) => add(sid, c));
      return;
    }
    const sellerKey = norm(c.distributionChannel);
    if (sellerKey) add(sellerKey, c);
  });

  return map;
}

function mergeKpiIntoBase(kpiSellers = [], customersBySeller = {}) {
  if (!Array.isArray(kpiSellers)) return [];

  return kpiSellers.map((seller) => {
    const sellerId = norm(seller.salesPersonId);
    const base = (customersBySeller[sellerId] || []).map((c) => ({
      ...c,
      salesAmount: Number(c.salesAmount || 0),
      salesQuantity: Number(c.salesQuantity || 0),
      LineProduct: normalizeLineProducts(c.LineProduct), 
    }));

    const map = new Map(base.map((c) => [norm(c.customerId), { ...c }]));
    (seller.custType || []).forEach((sc) => {
      const cid = norm(sc.customerId);
      if (!cid) return;

      const prev =
        map.get(cid) ||
        ({
          customerId: cid,
          customerName: sc.customerName || "",
          typeId: sc.typeId || null,
          typeName: sc.typeName || null,
          potential: Number(sc.potential || 0),
          percentaje: Number(sc.percentaje || 0),
          lastVisitDate: sc.lastVisitDate || null,
          salesAmount: 0,
          salesQuantity: 0,
          LineProduct: normalizeLineProducts([]),
        });

      const incomingLP =
        Array.isArray(sc.LineProduct) && sc.LineProduct.length
          ? normalizeLineProducts(sc.LineProduct)
          : prev.LineProduct;

      map.set(cid, {
        ...prev,
        ...sc,
        salesAmount: Number(sc.salesAmount ?? prev.salesAmount ?? 0),
        salesQuantity: Number(sc.salesQuantity ?? prev.salesQuantity ?? 0),
        LineProduct: incomingLP,
      });
    });
    const custType = [...map.values()].map((c) => ({
      ...c,
      salesAmount: Number(c.salesAmount || 0),
      salesQuantity: Number(c.salesQuantity || 0),
      LineProduct: normalizeLineProducts(c.LineProduct),
    }));

    return {
      ...seller,
      custType,
    };
  });
}


function buildLineProductResume(customers = [], filterType = "salesAmount") {
  const totalClients = customers.length;
  const map = new Map(); 

  const getClientKey = (c) =>
    (c.customerId || c.customer_id || c.customerName || c.name || "").toString().trim();

  customers.forEach((cust) => {
    const clientKey = getClientKey(cust) || JSON.stringify(cust);

    (cust.LineProduct || []).forEach((lp) => {
      const name = (lp.Name || "").toString().trim();
      if (!name) return;

      const key = name.toUpperCase();
      const value =
        filterType === "salesQuantity"
          ? Number(lp.salesQuantity || 0)
          : Number(lp.salesAmount || 0);

      if (!map.has(key)) {
        map.set(key, {
          name,
          total: 0,
          clients: new Set(),
          order: Number.isFinite(lp.order) ? lp.order : 9999,
        });
      }

      const acc = map.get(key);
      acc.total += value;
      acc.order = Math.min(acc.order, Number.isFinite(lp.order) ? lp.order : 9999);
      if (value > 0) acc.clients.add(clientKey);
    });
  });

  return [...map.values()]
    .sort((a, b) => (a.order - b.order) || (b.clients.size - a.clients.size) || (b.total - a.total))
    .map((x) => ({
      lineName: x.name,
      total: x.total,
      clientsWithSales: x.clients.size,
      totalClients,
    }));
}



const TableF = ({ data, user, filterType, onGoalChange, selectedWeek, realDays, userGoal, potentialFactor }) => {
  const [expandedTypes, setExpandedTypes] = useState({});
  const custTypes = [
    "BORDADOR",
    "IMPRESOR",
    "TEXTILES (UNIFORMES)",
    "COMERCIALIZADOR",
    "PROMOCIONAL",
    "USO PERSONAL",
    "Sin clasificar",
  ];

  const filteredData = useMemo(() => {
    return filterSellersForUser(data, user);
  }, [data, user]);
  
  const toggleExpand = (sellerIndex, typeName) => {
    setExpandedTypes((prev) => ({
      ...prev,
      [sellerIndex]: prev[sellerIndex] === typeName ? null : typeName,
    }));
  };

  if (!Array.isArray(filteredData) || filteredData.length === 0) {
    return <p>No hay datos disponibles para este vendedor.</p>;
  }
  return (
    <div>
      {filteredData.map((seller, sellerIndex) => {
        

        
        return (
          <div key={sellerIndex} style={{ marginBottom: "40px" }}>
{isAdminLikeDepartment(user.departmentId) && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                  padding: "0 20px",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                {(() => {
                  const custType = seller.custType || [];

                  const totalClientesVendedor = custType.length;

                  const totalVentasVendedor = custType.reduce(
                    (sum, c) => sum + (c.salesAmount || 0),
                    0
                  );

                  

                  const totalConVenta = custType.filter(
                    (c) => (c.salesAmount || 0) > 0
                  ).length;

                  const totalPotencialBase = custType.reduce(
                    (sum, c) => sum + (c.potential || 0),
                    0
                  );
                  
                  const pf = (potentialFactor ?? 1);
                  const totalPotencial = totalPotencialBase * pf;
                                    
                  const objetivoDelVendedor = seller.salesObjetive || 0;
                  
                  return (
                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "4px" }}>
                        {seller.name}
                        {"\u00A0\u00A0 - Pesos:  "}
                        {totalVentasVendedor.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                  
                        {" - Presupuesto: $"}
                        {objetivoDelVendedor.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                        {"\u00A0\u00A0 - Clientes: "}
                        {totalClientesVendedor}
                        {"\u00A0\u00A0 - Clientes con venta: "}
                        {totalConVenta}
                        {"\u00A0\u00A0 - Potencial "}
                        {totalPotencial.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </div>
                    </div>
                  );
                  
                })()}
              </div>
            )}

            <div
              style={{
                display: "flex",
                gap: "20px",
                flexWrap: "nowrap",
                overflowX: "auto",
                paddingBottom: "10px",
              }}
            >
              {custTypes.map((typeName, index) => {
                const filteredCusts = (seller.custType || []).filter((cust) =>
                  typeName === "Sin clasificar"
                    ? !cust.typeName && !cust.typeId
                    : cust.typeName === typeName
                );

                const totalClients = filteredCusts.length;
                const totalSalesAmount = filteredCusts.reduce(
                  (sum, cust) => sum + (cust.salesAmount || 0),
                  0
                );
                const totalSalesQty = filteredCusts.reduce(
                  (sum, cust) => sum + (cust.salesQuantity || 0),
                  0
                );
                const clientsWithSales = filteredCusts.filter(
                  (cust) => (cust.salesAmount || 0) > 0
                ).length;

                const objetivoTipo = (() => {
                  const objetivoVendedor = Number(seller.salesObjetive) || 0;
                  const totalClientesVendedor = (seller.custType?.length || 0);
                  if (!totalClientesVendedor) return 0;
                  return objetivoVendedor * (totalClients / totalClientesVendedor);
                })();
                const totalPotential = filteredCusts.reduce(
                  (sum, cust) => sum + (cust.potential || 0),
                  0
                );
                const totalPotentialAdj = totalPotential * (potentialFactor ?? 1);

                return (
                  <div
                    key={index}
                    style={{
                      minWidth: "300px",
                      minHeight: "240px",
                      padding: "16px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "stretch",
                      justifyContent: "space-between",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      backgroundColor: "#fff",
                      fontSize: "18px",
                      gap: "8px",
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <strong>Total Clientes:</strong>
                      <span>{totalClients}</span>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <strong>Con venta:</strong>
                      <span>{clientsWithSales}</span>
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "bold" }}>
                      <span>{filterType === "salesAmount" ? "Pesos:" : "Piezas:"}</span>
                      <span>
                        {filterType === "salesAmount"
                          ? `$${Math.round(totalSalesAmount).toLocaleString("en-US")}`
                          : `${totalSalesQty.toLocaleString("en-US")}`}
                      </span>
                    </div>

                    {filterType === "salesAmount" && (
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontWeight: "bold" }}>Presupuesto:</span>
                        <span style={{ fontWeight: "bold" }}>
                          ${objetivoTipo.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    )}

                    {filterType === "salesAmount" && (
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontWeight: "bold" }}>Potencial:</span>
                        <span style={{ fontWeight: "bold" }}>
                          ${totalPotentialAdj.toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </span>
                      </div>
                    )}

                    <button
                      onClick={() => toggleExpand(sellerIndex, typeName)}
                      style={{
                        padding: "12px 16px",
                        fontSize: "20px",
                        backgroundColor:
                          expandedTypes[sellerIndex] === typeName ? "#28a745" : "#007bff",
                        color: "#fff",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer",
                        marginTop: "auto",
                        fontWeight: "bold",
                      }}
                    >
                      {typeName}
                    </button>
                  </div>
                );
              })}
            </div>

            {custTypes.map(
(typeName) =>
  expandedTypes[sellerIndex] === typeName && (
    <div key={typeName}>
      {(() => {
        const custRows = (seller.custType || []).filter((cust) =>
          typeName === "Sin clasificar"
            ? !cust.typeName && !cust.typeId
            : cust.typeName === typeName
        );

        if (!custRows.length) return <p>No hay clientes para este tipo.</p>;

        const resume = buildLineProductResume(custRows, filterType);
        const resumeByName = new Map(resume.map((r) => [r.lineName, r]));

        const orderMap = new Map();
        custRows.forEach((cust) => {
          (cust.LineProduct || []).forEach((lp) => {
            const name = (lp.Name || "").toString().trim();
            if (!name) return;
            const ord = Number.isFinite(lp.order) ? lp.order : 9999;
            if (!orderMap.has(name) || ord < orderMap.get(name)) orderMap.set(name, ord);
          });
        });

        const allLineNamesGlobal = [...orderMap.entries()]
          .sort((a, b) => a[1] - b[1] || a[0].localeCompare(b[0]))
          .map(([name]) => name);

        return (
          <table border="1" style={{ width: "100%", marginTop: "10px" }}>
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Pot</th>
                {filterType === "salesAmount" ? <th>Pesos</th> : <th>Piezas</th>}
                <th>Detalle por línea</th>
              </tr>

              <tr>
                <th colSpan={3} />
                <th className="lineHeadCell">
                  <div className="lineScrollRow lineHeadScroll">
                    {allLineNamesGlobal.map((lineName) => {
                      const p = resumeByName.get(lineName) || {
                        lineName,
                        clientsWithSales: 0,
                        totalClients: custRows.length,
                        total: 0,
                      };
                      const isZero = p.clientsWithSales === 0;

                      return (
                        <div
                          key={lineName}
                          className={`lineResumeCard ${isZero ? "zero" : "has"}`}
                          title={`${p.lineName} — ${p.clientsWithSales}/${p.totalClients}`}
                        >
                          <div className="lineResumeName">{p.lineName}</div>
                          <div className="lineResumeMeta">
                            {p.clientsWithSales}/{p.totalClients} clientes
                          </div>
                          <div className="lineResumeTotal">
                            {filterType === "salesAmount"
                              ? `$${Number(p.total || 0).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`
                              : Number(p.total || 0).toLocaleString("en-US")}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {custRows
                .slice()
                .sort((a, b) => (b.potential || 0) - (a.potential || 0))
                .map((cust, i) => {
                  const lineMap = {};
                  (cust.LineProduct || []).forEach((lp) => {
                    const key = (lp.Name || "").toString().trim();
                    if (!key) return;
                    lineMap[key] = {
                      amount: lp.salesAmount || 0,
                      quantity: lp.salesQuantity || 0,
                      order: lp.order ?? 0,
                    };
                  });
                  const sumFromLines = (cust.LineProduct || []).reduce(
                    (acc, lp) => acc + (lp.salesAmount || 0),
                    0
                  );

                  if (Math.abs(sumFromLines - (cust.salesAmount || 0)) > 1) {
                    console.warn("Diferencia detectada:", {
                      cliente: cust.customerName,
                      totalReported: cust.salesAmount,
                      sumFromLines,
                      diferencia: sumFromLines - cust.salesAmount,
                    });
                  }

                  const LIMIT_DAYS = 30;
                  const visitDate = cust.lastVisitDate ? new Date(cust.lastVisitDate) : null;
                  const validVisit = visitDate && !Number.isNaN(visitDate.getTime());

                  const today = new Date();
                  const diffDays = validVisit
                    ? Math.floor(
                        (Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()) -
                          Date.UTC(
                            visitDate.getFullYear(),
                            visitDate.getMonth(),
                            visitDate.getDate()
                          )) / 86400000
                      )
                    : null;

                  const isOldVisit = !validVisit || diffDays >= LIMIT_DAYS;

                  const lastVisitLabel = validVisit
                    ? visitDate.toLocaleDateString("es-MX", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                    : "Sin registro";

                  return (
                    <tr key={i} style={{ textAlign: "center" }}>
                      <td style={{ padding: "12px", textAlign: "left" }}>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                          title={`Última visita: ${lastVisitLabel}${
                            validVisit ? ` (${diffDays} días)` : ""
                          }`}
                        >
                          {(cust.customerName || "")
                            .toString()
                            .split(" ")
                            .filter(Boolean)
                            .map((part, idx) => (
                              <span key={idx} style={{ color: isOldVisit ? "red" : "#333" }}>
                                {part}
                              </span>
                            ))}
                        </div>
                      </td>

                      <td>${Math.round(cust.potential || 0).toLocaleString("en-US")}</td>

                      {filterType === "salesAmount" ? (
                        <td>${Math.round(cust.salesAmount || 0).toLocaleString("en-US")}</td>
                      ) : (
                        <td>{(cust.salesQuantity || 0).toLocaleString("en-US")}</td>
                      )}

                      <td className="lineBodyCell">
                        <div className="lineScrollRow lineBodyScroll">
                          {allLineNamesGlobal.map((lineName, idx) => {
                            const { amount = 0, quantity = 0 } = lineMap[lineName] || {};
                            const isZero =
                              filterType === "salesAmount"
                                ? Number(amount) === 0
                                : Number(quantity) === 0;

                            return (
                              <div
                                key={idx}
                                className="lineChip"
                                style={{ color: isZero ? "red" : "inherit" }}
                              >
                                <div>
                                  <strong>{lineName}</strong>
                                </div>
                                <div style={{ color: isZero ? "red" : "#333" }}>
                                  <strong>
                                    {filterType === "salesAmount"
                                      ? `$${Number(amount).toLocaleString("en-US", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })}`
                                      : Number(quantity).toLocaleString("en-US")}
                                  </strong>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        );
      })()}
    </div>
  )
)}
          </div>
        );
      })}
    </div>
  );
};

class ModalIndicators extends React.Component {

  state = {
    user: JSON.parse(localStorage.getItem('user')),
    data: [],
    dateSelectDraft: null,
dateEndSelectDraft: null,
territoriesLoaded: false,
territoriesLoading: false,
territoriesError: null,
sellerToTerritory: {},       
territoryToSellers: {},       

    dateSelect: null,
    dateEndSelect: null,
    selectedMonth: null,
    customersLoaded: false,
  customersLoading: false,
  customersError: null,
  customersBySeller: {},
    realDays:0,
    userGoal: 0,
    dataByWeeklySale: [],
    selectedWeek: null,
    dataClass: [],
    loggedInsalesPersonId:[],
    userId: [],
    dataprincipalIndicator:[],
    dataByweeklySaleByClassTerr: [],
    dataByweeklysalesByClassChan: [],
    dataByweeklysalesByClassSlspsn: [],
    dataByweeklysalesBysalesByGroup:[],
    dataSalesByCustomerType: [],
    salesFilterType: "salesAmount",
    salesFilterTypeObj: { label: "Pesos", value: "salesAmount" },
    loading: false,
    salesData: [],
    LineProduct	:[],
    dataByweeklysalesBysalesByTypeCust: [],
    custType:[],
    customerClasses: [
      { id: 'AAA', name: 'AAA' },
      { id: 'AA', name: 'AA' },
      { id: 'A', name: 'A' },
      { id: 'C', name: 'C' },
    ]
  };

  async componentDidMount() {
    const today = new Date();
    const currentWeek = this.getWeek();
    const currentMonthNumber = today.getMonth() + 1;
    const formattedMonth = String(currentMonthNumber).padStart(2, '0');

    const months = [
      { label: 'Enero', value: '01' },
      { label: 'Febrero', value: '02' },
      { label: 'Marzo', value: '03' },
      { label: 'Abril', value: '04' },
      { label: 'Mayo', value: '05' },
      { label: 'Junio', value: '06' },
      { label: 'Julio', value: '07' },
      { label: 'Agosto', value: '08' },
      { label: 'Septiembre', value: '09' },
      { label: 'Octubre', value: '10' },
      { label: 'Noviembre', value: '11' },
      { label: 'Diciembre', value: '12' },
    ];

    const selectedMonth = months.find(m => m.value === formattedMonth);

    this.setState({
      selectedWeek: { value: currentWeek, label: `Semana ${currentWeek}` },
      selectedMonth,
      loading: false,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.onChangeTab("6");
    }

    if (
      prevState.salesFilterType !== this.state.salesFilterType &&
      this.state.dataSalesByCustomerType.length > 0
    ) {
      const userProgress = this.state.dataSalesByCustomerType.reduce(
        (sum, seller) =>
          sum +
          (seller.custType || []).reduce(
            (s, c) =>
              s +
              (this.state.salesFilterType === "salesAmount"
                ? c.salesAmount || 0
                : c.salesQuantity || 0),
            0
          ),
        0
      );

      this.setState({ userProgress });
    }
  }
  ensureCustomersLoaded = async () => {
    if (this.state.customersLoaded || this.state.customersLoading) return;
  
    this.setState({ customersLoading: true, customersError: null });
  
    try {
      await this.ensureTerritoriesLoaded();
  
      const cached = safeJsonParse(localStorage.getItem(CUSTOMERS_CACHE_KEY), null);
    
      if (
        cached?.ts &&
        Array.isArray(cached.data) &&
        (Date.now() - cached.ts) < CUSTOMERS_CACHE_TTL_MS
      ) {
        const customersSlim = cached.data;
  
        const terrMap = this.state.territoryToSellers || {};
  
        const customersBySeller = buildCustomersBySellerWithTerritory(
          customersSlim,
          terrMap
        );
  
  
        this.setState({
          customersBySeller,
          customersLoaded: true,
          customersLoading: false,
          customersLoadedAt: new Date(cached.ts),
        });
  
        return;
      }
        const customers = await this.fetchAllCustomers();
      const customersSlim = Array.isArray(customers) ? customers.map(slimCustomer) : [];
  
      const terrMap = this.state.territoryToSellers || {};
  
      const customersBySeller = buildCustomersBySellerWithTerritory(
        customersSlim,
        terrMap
      );
  
  
      this.setState({
        customersBySeller,
        customersLoaded: true,
        customersLoading: false,
        customersLoadedAt: new Date(),
      });
  
      try {
        localStorage.setItem(
          CUSTOMERS_CACHE_KEY,
          JSON.stringify({ ts: Date.now(), data: customersSlim })
        );
      } catch (e) {
        console.warn("No se pudo cachear clientes:", e);
        try { localStorage.removeItem(CUSTOMERS_CACHE_KEY); } catch {}
      }
  
    } catch (e) {
      console.error("Error cargando clientes base:", e);
      this.setState({
        customersLoading: false,
        customersLoaded: false,
        customersError: e?.message || "Error cargando clientes",
        customersBySeller: {},
      });
    }
  };

  fetchAllCustomers = async () => {
    const resp = await axios.get("/api/clients", {
      params: { active: true },
      withCredentials: true,
    });
  
    const raw = resp?.data;
  
    if (raw?.read?.[0]?.data && Array.isArray(raw.read[0].data)) return raw.read[0].data;
    if (Array.isArray(raw?.data)) return raw.data;
    if (Array.isArray(raw)) return raw;
  
    return [];
  };
      
  fetchAllTerritories = async () => {
    const resp = await axios.get("/api/territories", {
      withCredentials: true,
    });
  
    const rows = extractTerritoriesArray(resp); 
    return rows;
  };
    
  ensureTerritoriesLoaded = async () => {
    if (this._terrPromise) return this._terrPromise;
  
    this._terrPromise = (async () => {
      if (this.state.territoriesLoaded || this.state.territoriesLoading) return;
  
      this.setState({ territoriesLoading: true, territoriesError: null });
  
      try {
        const cached = safeJsonParse(localStorage.getItem(TERR_CACHE_KEY), null);
  
        if (
          cached?.ts &&
          Array.isArray(cached.data) &&
          cached.data.length > 0 &&
          (Date.now() - cached.ts) < TERR_CACHE_TTL_MS
        ) {
          const { sellerToTerritory, territoryToSellers } =
            buildTerritoryIndex(cached.data);
  
          const territories = cached.data
            .map((t) => ({ value: String(t.id).trim(), label: String(t.name || "").trim() }))
            .filter((t) => t.value && t.label);
  
          this.setState({
            territoriesLoaded: true,
            territoriesLoading: false,
            territoriesError: null,
            territories,
            sellerToTerritory,
            territoryToSellers,
          });
          return;
        }
          const rows = await this.fetchAllTerritories();
        const list = Array.isArray(rows) ? rows : [];
          if (!list.length) {
          console.warn("territories API vacía; sin fallback (índices vacíos)");
          this.setState({
            territoriesLoaded: true,
            territoriesLoading: false,
            territoriesError: null,
            territories: [],
            sellerToTerritory: {},
            territoryToSellers: {},
          });
          return;
        }
                  const { sellerToTerritory,territoryToSellers } =
          buildTerritoryIndex(list);
  
        const territories = list
          .map((t) => ({ value: String(t.id).trim(), label: String(t.name || "").trim() }))
          .filter((t) => t.value && t.label);
  
        this.setState({
          territoriesLoaded: true,
          territoriesLoading: false,
          territoriesError: null,
          territories,
          sellerToTerritory,
          territoryToSellers,
        });
  
        try {
          localStorage.setItem(TERR_CACHE_KEY, JSON.stringify({ ts: Date.now(), data: list }));
        } catch (e) {
          console.warn("No se pudo cachear territorios:", e);
          try { localStorage.removeItem(TERR_CACHE_KEY); } catch {}
        }
      } catch (e) {
        console.error("Error cargando territorios:", e);
        this.setState({
          territoriesLoaded: false,
          territoriesLoading: false,
          territoriesError: e?.message || "Error cargando territorios",
          territories: [],
          sellerToTerritory: {},
          territoryToSellers: {},
        });
      }
    })();
  
    try {
      await this._terrPromise;
    } finally {
      this._terrPromise = null;
    }
  };
        
  loadTerritories = async (inputValue = "", callback) => {
    await this.ensureTerritoriesLoaded();
  
    const q = (inputValue || "").toLowerCase().trim();
    const all = this.state.territories || [];
  
    const filtered = q
      ? all.filter((t) =>
          (t.label || "").toLowerCase().includes(q) ||
          (t.value || "").toLowerCase().includes(q)
        )
      : all;
  
    callback(filtered.slice(0, 200));
  };
    
  handleTerritoryChange = (selectedTerritory) => {
    this.setState({ selectedTerritory: selectedTerritory || null }, async () => {
      const { dateSelect, dateEndSelect, selectedMonth, selectedWeek } = this.state;
  
      if (selectedWeek) {
        await this.handleWeekChangeSales(selectedWeek);
        return;
      }
  
      if (selectedMonth && dateSelect && dateEndSelect) {
        await this.handleMonthChangeByTypeCust(selectedMonth);
        return;
      }
  
      if (dateSelect && dateEndSelect) {
        await this.changedDate(dateSelect, dateEndSelect);
        return;
      }
      });
  };
  getCustomersBySellerFiltered = () => {
    const base = this.state.customersBySeller || {};
    const terrId = norm(this.state.selectedTerritory?.value);
    const terrName = norm(this.state.selectedTerritory?.label);
  
    if (!terrId && !terrName) return base;
  
    const out = {};
    Object.keys(base).forEach((sellerId) => {
      const arr = base[sellerId] || [];
      out[sellerId] = arr.filter((c) => {
        const cTerr = norm(c.territory || c.territoryId || c.territoryCode);
        return (terrId && cTerr === terrId) || (terrName && cTerr === terrName);
      });
    });
  
    return out;
  };
    
  
  applyCustomersBaseToKpi = (finalData) => {
    const customersMap = this.getCustomersBySellerFiltered();
    return mergeKpiIntoBase(finalData, customersMap);
  };
      async onChangeTab(tabNum) {

    this.setState({ loading: true });
    const tabNumIdx = tabNum;

    this.setState({ tabNumIdx });

    if (tabNumIdx === "6") {

      const today = new Date();
      const currentMonth = today.getMonth();
      const startOfMonth = new Date(today.getFullYear(), currentMonth, 1);
      const isCurrentMonth =
        today.getMonth() === currentMonth &&
        today.getFullYear() === new Date().getFullYear();
      const endOfMonth = isCurrentMonth
        ? today
        : new Date(today.getFullYear(), currentMonth + 1, 0);

      const realDays = Math.floor((endOfMonth - startOfMonth) / (1000 * 60 * 60 * 24)) + 1;

      const selectedMonthOption = {
        label: startOfMonth.toLocaleString("es-MX", { month: "long" }),
        value: (currentMonth + 1).toString().padStart(2, "0"),
      };

      this.setState(
        {
          selectedWeek: null,
          selectedMonth: selectedMonthOption,
          dateSelect: startOfMonth,
          dateEndSelect: endOfMonth,
          dateSelectDraft: startOfMonth,
          dateEndSelectDraft: endOfMonth,
          realDays,
          loading: true,
        },
        async () => {
          const formatDate = (date) => {
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            return `${month}/${day}/${year}`;
          };

          const formattedStartDate = formatDate(startOfMonth);
          const formattedEndDate = formatDate(endOfMonth);


          try {
            const user = this.state.user;
            const salesPersonId = this.getSalesPersonId(user);
            await this.ensureCustomersLoaded(); 
                      
            const response = await qad.catalog.kpi.weeklysalesBysalesByTypeCust(
              "",
              salesPersonId,
              "",
              formattedStartDate,
              formattedEndDate
            );
          
            let finalData = Array.isArray(response) ? response : [];
          
            finalData = finalData.map((seller) => ({
              ...seller,
              salesObjetive: (seller.salesObjetive || 0) * realDays / 30,
            }));
          
            if (this.state.customersLoaded) {
              finalData = this.applyCustomersBaseToKpi(finalData);
            }
          
            const userProgress = finalData.reduce(
              (sum, seller) =>
                sum +
                (seller.custType || []).reduce(
                  (s, c) =>
                    s +
                    (this.state.salesFilterType === "salesAmount"
                      ? c.salesAmount || 0
                      : c.salesQuantity || 0),
                  0
                ),
              0
            );
          
            const userGoal = finalData.reduce((sum, seller) => sum + (seller.salesObjetive || 0), 0);
          
            this.setState({
              dataSalesByCustomerType: finalData,
              userGoal,
              userProgress,
            });
          } catch (error) {
            console.error("Error al cargar datos de la pestaña 6:", error);
            this.setState({
              dataSalesByCustomerType: [],
              userGoal: 0,
              userProgress: 0,
            });
          } finally {
            this.setState({ loading: false });
          }
                  }
      );
    }
  }

  getDaysBetween() {
    const { dateSelect, dateEndSelect, selectedMonth, selectedWeek } = this.state;

    if (selectedWeek) return 6;

    if (selectedMonth && dateSelect && dateEndSelect) {
      return Math.floor((dateEndSelect - dateSelect) / (1000 * 60 * 60 * 24)) + 1;
    }

    if (dateSelect && dateEndSelect) {
      return Math.floor((dateEndSelect - dateSelect) / (1000 * 60 * 60 * 24)) + 1;
    }

    return 0;
  }

  loadWeeks = async (inputValue = '', callback) => {
    const totalWeeks = 52;
    const weeks = Array.from({ length: totalWeeks }, (_, i) => {
      const weekNumber = i + 1;
      return {
        label: `Semana ${weekNumber}`,
        value: weekNumber,
      };
    });

    const filtered = weeks.filter((w) =>
      w.label.toLowerCase().includes(inputValue.toLowerCase())
    );

    callback(filtered);
  };
  getWeekDateRange(weekNumber) {
    const year = new Date().getFullYear();
    const firstDayOfYear = new Date(year, 0, 1);
    const firstDayOfWeek = firstDayOfYear.getDay();
    const offsetToMonday = (firstDayOfWeek === 0 ? 1 : 8 - firstDayOfWeek);
    const startDate = new Date(year, 0, 1 + offsetToMonday + (weekNumber - 2) * 7);
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 5); 
    return { startDate, endDate };
  }
  fetchDataByWeekRange = async (week, salesPersonId) => {
    const allData = [];

    const { startDate, endDate } = this.getWeekDateRange(week);

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    try {
      const weeklyData = await qad.catalog.kpi.weeklysalesBysalesByTypeCust(
        week.toString(),
        salesPersonId,
        '',
        formattedStartDate,
        formattedEndDate
      );

      if (Array.isArray(weeklyData)) {
        allData.push(...weeklyData);
      }
    } catch (error) {
      console.error("Error al obtener datos:", error);
    }

    const groupedData = {};
    allData.forEach((item) => {
      if (!groupedData[item.salesPersonId]) {
        groupedData[item.salesPersonId] = { ...item };
      } else {
        (item.custType || []).forEach((cust, i) => {
          const existing = groupedData[item.salesPersonId].custType[i];
          existing.salesAmount += cust.salesAmount || 0;
          existing.salesQuantity += cust.salesQuantity || 0;
        });
      }
    });

    const finalData = Object.values(groupedData);
    const { salesFilterType } = this.state;

    const userProgress = finalData.reduce((sum, seller) =>
      sum +
      seller.custType.reduce((s, c) =>
        s + (salesFilterType === "salesAmount" ? c.salesAmount || 0 : c.salesQuantity || 0), 0
      ), 0
    );

    const userGoal = finalData.reduce((sum, seller) => {
      const days = seller.days || 1;
      return sum + (seller.salesObjetive * days / 30);
    }, 0);

    const days = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

    return { finalData, userProgress, userGoal, days };
  };

  handleWeekChangeSales = async (selectedWeek) => {
    if (!selectedWeek) return;
  
    const today = new Date();
    const currentWeek = this.getWeekNumber(today.toISOString().split('T')[0]);
  
    if (selectedWeek.value > currentWeek) {
      Swal.fire({
        icon: 'warning',
        title: 'Semana inválida',
        text: `No puedes seleccionar la semana ${selectedWeek.value} porque aún no ha ocurrido.`,
      });
      this.setState({ selectedWeek: null });
      return;
    }
  
    this.setState({
      loading: true,
      selectedWeek,
      selectedMonth: null,
      dateSelect: null,
      dateEndSelect: null,
      dateSelectDraft: null,
  dateEndSelectDraft: null,
    });
  
    try {
      const { user } = this.state;
      const week = selectedWeek.value;
  
      const salesPersonId = this.getSalesPersonId(user);
        const { finalData: rawData, userGoal, userProgress, days } =
        await this.fetchDataByWeekRange(week, salesPersonId);
        await this.ensureCustomersLoaded();
      const finalData = this.state.customersLoaded
        ? this.applyCustomersBaseToKpi(rawData)
        : rawData;
  
      this.setState({
        dataSalesByCustomerType: finalData,
        userGoal,
        userProgress,
        realDays: days,
      });
    } catch (error) {
      console.error("Error al cargar datos por semana:", error);
      this.setState({ dataSalesByCustomerType: [], userProgress: 0, userGoal: 0 });
    } finally {
      this.setState({ loading: false });
    }
  };
  
  changedDate = async (start, end) => {
    if (!(start instanceof Date) || isNaN(start) || !(end instanceof Date) || isNaN(end)) {
      this.setState({
        dateSelect: null,
        dateEndSelect: null,
        dataSalesByCustomerType: [],
        userProgress: 0,
        userGoal: 0,
      });
      return;
    }
  
    const today = new Date();
    if (start > today || end > today) {
      Swal.fire({
        icon: "warning",
        title: "Rango no válido",
        text: "No puedes seleccionar fechas futuras.",
      });
      return;
    }
  
    const realDays = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;
  
    this.setState({
      dateSelect: start,
      dateEndSelect: end,
      dateSelectDraft: start,
      dateEndSelectDraft: end,
    
      selectedMonth: null,
      selectedWeek: null,
      realDays,
      loading: true,
    });
      
    try {
      const { user, salesFilterType } = this.state;
      const salesPersonId = this.getSalesPersonId(user);
  
      const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      };
  
      const formattedStartDate = formatDate(start);
      const formattedEndDate = formatDate(end);
        await this.ensureCustomersLoaded();
        const response = await qad.catalog.kpi.weeklysalesBysalesByTypeCust(
        "",
        salesPersonId,
        "",
        formattedStartDate,
        formattedEndDate
      );
  
      let finalData = Array.isArray(response) ? response : [];
        finalData = finalData.map((seller) => ({
        ...seller,
        salesObjetive: (seller.salesObjetive || 0) * realDays / 30,
      }));
        if (this.state.customersLoaded) {
        finalData = this.applyCustomersBaseToKpi(finalData);
      }
  
      const userProgress = finalData.reduce(
        (sum, seller) =>
          sum +
          (seller.custType || []).reduce(
            (s, c) =>
              s +
              (salesFilterType === "salesAmount"
                ? c.salesAmount || 0
                : c.salesQuantity || 0),
            0
          ),
        0
      );
  
      const userGoal = finalData.reduce((sum, seller) => sum + (seller.salesObjetive || 0), 0);
  
      this.setState({
        dataSalesByCustomerType: finalData,
        userGoal,
        userProgress,
      });
    } catch (error) {
      console.error("Error en changedDate:", error);
      this.setState({ dataSalesByCustomerType: [], userProgress: 0, userGoal: 0 });
    } finally {
      this.setState({ loading: false });
    }
  };
    
  loadFilterOptions = (inputValue, callback) => {
    const options = [
      { label: "", value: "salesAmount" },
      { label: "Piezas", value: "salesQuantity" }
    ];

    const filtered = options.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );

    callback(filtered);
  };

  handleFilterTypeChange = (selected) => {
    if (selected) {
      this.setState({
        salesFilterType: selected.value,
        salesFilterTypeObj: selected
      });
    } else {
      this.setState({
        salesFilterType: "salesAmount",
        salesFilterTypeObj: { label: "", value: "salesAmount" }
      });
    }
  };

  handleSearchDateRange = async () => {
    const { dateSelectDraft, dateEndSelectDraft } = this.state;
  
    if (!dateSelectDraft && !dateEndSelectDraft) {
      this.changedDate(null, null);
      return;
    }
      if (!(dateSelectDraft instanceof Date) || isNaN(dateSelectDraft) ||
        !(dateEndSelectDraft instanceof Date) || isNaN(dateEndSelectDraft)) {
      Swal.fire({
        icon: "warning",
        title: "Rango incompleto",
        text: "Selecciona Fecha Inicio y Fecha Fin.",
      });
      return;
    }
  
    if (dateSelectDraft > dateEndSelectDraft) {
      Swal.fire({
        icon: "warning",
        title: "Rango no válido",
        text: "La Fecha Inicio no puede ser mayor a la Fecha Fin.",
      });
      return;
    }
      await this.changedDate(dateSelectDraft, dateEndSelectDraft);
  };
  
  getWeek() {
    const now = new Date();
    let day = now.getDay();
    day = day >= 0 ? day : day + 7;
    const onejan = new Date(now.getFullYear(), 0, 1);
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const dayOfYear = Math.floor((today - onejan) / 86400000) + 1;

    let weeknum;
    if (day < 4) {
      weeknum = Math.floor((dayOfYear + day - 1) / 7) + 1;
      if (weeknum > 52) {
        let nYear = new Date(now.getFullYear() + 1, 0, 1);
        let nday = nYear.getDay();
        nday = nday >= 0 ? nday : nday + 7;
        weeknum = nday < 4 ? 1 : 53;
      }
    } else {
      weeknum = Math.floor((dayOfYear + day - 1) / 7);
    }

    return weeknum;
  }

  getSalesPersonId(user) {
    const dep = String(user?.departmentId || "").trim();
    const sp = (user?.salesPersonId || "").toString().trim().toUpperCase();
      if (dep === "001" || dep === "002" || dep === "008") {
      return "VANG";
    }
  
    return sp || "";
  }
    
  getWeekNumber(dateString) {
    const date = new Date(dateString);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    const firstThursday = new Date(date.getFullYear(), 0, 4);
    const weekNumber = 1 + Math.round(((date - firstThursday) / 86400000 - 3 + ((firstThursday.getDay() + 6) % 7)) / 7);
    return weekNumber;
  }

  loadMonths = async (inputValue = '', callback) => {
    const months = [
      { label: 'Enero', value: '01' },
      { label: 'Febrero', value: '02' },
      { label: 'Marzo', value: '03' },
      { label: 'Abril', value: '04' },
      { label: 'Mayo', value: '05' },
      { label: 'Junio', value: '06' },
      { label: 'Julio', value: '07' },
      { label: 'Agosto', value: '08' },
      { label: 'Septiembre', value: '09' },
      { label: 'Octubre', value: '10' },
      { label: 'Noviembre', value: '11' },
      { label: 'Diciembre', value: '12' },
    ];

    const filtered = months.filter((m) =>
      m.label.toLowerCase().includes(inputValue.toLowerCase())
    );

    callback(filtered);
  };

  formatDisplayDate(date) {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day} / ${month} / ${year}`;
  }

  handleMonthChangeByTypeCust = (selectedOption) => {
    const today = new Date();
    const currentYear = today.getFullYear();

    const formatDate = (date) => {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    };

    if (!selectedOption) {
      this.setState({ selectedMonth: null });
      return;
    }

    const month = parseInt(selectedOption.value);
    const startDate = new Date(currentYear, month - 1, 1);
    const isCurrentMonth =
      month === today.getMonth() + 1 &&
      currentYear === today.getFullYear();

    const endDate = isCurrentMonth
      ? today
      : new Date(currentYear, month, 0);

    if (startDate > today) {
      Swal.fire({
        icon: "warning",
        title: "Mes no válido",
        text: "No puedes consultar un mes futuro.",
      });
      this.setState({ selectedMonth: null });
      return;
    }

    const realDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

    this.setState({
      selectedMonth: selectedOption,
      selectedWeek: null,
      dateSelect: startDate,
      dateEndSelect: endDate,
      dateSelectDraft: startDate,
      dateEndSelectDraft: endDate,
      realDays,
      loading: true,
    }, async () => {
      try {
        const { user, salesFilterType } = this.state;
        const salesPersonId = this.getSalesPersonId(user);
    
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);
    
        await this.ensureCustomersLoaded();
    
        const response = await qad.catalog.kpi.weeklysalesBysalesByTypeCust(
          '',
          salesPersonId,
          String(month).padStart(2, '0'),
          formattedStartDate,
          formattedEndDate
        );
    
        let finalData = Array.isArray(response) ? response : [];
    
        finalData = finalData.map((seller) => ({
          ...seller,
          salesObjetive: (seller.salesObjetive || 0) * realDays / 30,
        }));
    
        if (this.state.customersLoaded) {
          finalData = this.applyCustomersBaseToKpi(finalData);
        }
    
        const userProgress = finalData.reduce((sum, seller) =>
          sum + (seller.custType || []).reduce((s, c) =>
            s + (salesFilterType === "salesAmount" ? (c.salesAmount || 0) : (c.salesQuantity || 0)), 0
          ), 0
        );
    
        const userGoal = finalData.reduce((sum, seller) => sum + (seller.salesObjetive || 0), 0);
    
        this.setState({
          dataSalesByCustomerType: finalData,
          userProgress,
          userGoal,
          loading: false,
        });
      } catch (error) {
        console.error("Error al cargar datos mensuales:", error);
        this.setState({ loading: false });
      }
    });
  };

  handleStartDateChange = (date) => {
    this.setState({ dateSelectDraft: date || null });
  };
  
  handleEndDateChange = (date) => {
    this.setState({ dateEndSelectDraft: date || null });
  };
  
  render() {

    const user = JSON.parse(localStorage.getItem('user'));
    const { userGoal } = this.state;
    let totalClientesGlobal = 0;
    let totalConVentaGlobal = 0;
    let totalPotencialGlobal = 0;
    const { salesFilterType } = this.state;

    const potentialFactorGlobal = getPotentialFactorFromState(this.state);
    const visibleSellers = filterSellersForUser(this.state.dataSalesByCustomerType, user);

    visibleSellers.forEach((seller) => {
      (seller.custType || []).forEach((cust) => {
        totalClientesGlobal += 1;
        const value = salesFilterType === "salesAmount" ? cust.salesAmount || 0 : cust.salesQuantity || 0;
        if (value > 0) totalConVentaGlobal += 1;
        totalPotencialGlobal += (cust.potential || 0) * potentialFactorGlobal;
      });
    });

    return (
      <Modal isOpen={this.props.isOpen} onClose={this.props.onClose}>
        <h3>INDICADORES</h3>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "20px 30px",
            fontSize: "23px",
            fontWeight: "bold",
            flexWrap: "wrap",
            gap: "10px",
          }}

        >
          <div style={{ flex: "1", textAlign: "left" }}>
            CANAL: {["001", "002", ""].includes(user.departmentId) ? "ANTONIO GOMEZ" : user.name}
          </div>

          <div style={{ flex: "1", textAlign: "center" }}>
            {this.state.salesFilterType === "salesAmount" ? "Pesos" : "Piezas"}:{" "}
            {typeof this.state.userProgress === "number"
              ? this.state.salesFilterType === "salesAmount"
                ? `$${this.state.userProgress.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                : this.state.userProgress.toLocaleString("en-US")
              : "0.00"}
          </div>

          <div style={{ flex: "1", textAlign: "center" }}>
            Presupuesto:{" "}
            {typeof userGoal === "number"
              ? `$${userGoal.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : "$0.00"}
          </div>

          <div style={{ flex: "1", textAlign: "center" }}>
            Potencial:{" "}
            {`$${totalPotencialGlobal.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`}
          </div>

          <div style={{ flex: "1", textAlign: "center" }}>Clientes: {totalClientesGlobal}</div>
          <div style={{ flex: "1", textAlign: "right" }}>Clientes con venta: {totalConVentaGlobal}</div>
        </div>

        <Row
          style={{
            marginTop: '1rem',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '1rem',
            fontSize: '21px',
          }}
        >
          <Col>
            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Selecciona una semana:</label>
            <AsyncSelect
              id="weekSelector"
              placeholder="Selecciona una semana"
              cacheOptions
              defaultOptions
              isClearable
              loadOptions={this.loadWeeks}
              value={this.state.selectedWeek}
              onChange={this.handleWeekChangeSales}
              styles={{
                control: (base) => ({ ...base, fontSize: "14px" }),
                option: (base) => ({ ...base, fontSize: "14px" }),
              }}
            />
          </Col>

          <Col>
            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Selecciona un mes:</label>
            <AsyncSelect
              id="monthSelector"
              placeholder="Selecciona un mes"
              cacheOptions
              defaultOptions
              isClearable
              loadOptions={this.loadMonths}
              value={this.state.selectedMonth}
              onChange={this.handleMonthChangeByTypeCust}
              styles={{
                control: (base) => ({ ...base, fontSize: "14px" }),
                option: (base) => ({ ...base, fontSize: "14px" }),
              }}
            />
          </Col>

          <Col>
            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Fecha Inicio:</label>
            <input
  type="date"
  value={this.state.dateSelectDraft ? this.state.dateSelectDraft.toISOString().split("T")[0] : ""}
  onChange={(e) => {
    if (!e.target.value) {
      this.setState({ dateSelectDraft: null });
      return;
    }
    const [year, month, day] = e.target.value.split("-");
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    this.setState({ dateSelectDraft: date });
  }}
  style={{
    padding: "6px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  }}
/>
          </Col>

          <Col>
            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Fecha Fin:</label>
            <input
  type="date"
  value={this.state.dateEndSelectDraft ? this.state.dateEndSelectDraft.toISOString().split("T")[0] : ""}
  onChange={(e) => {
    if (!e.target.value) {
      this.setState({ dateEndSelectDraft: null });
      return;
    }
    const [year, month, day] = e.target.value.split("-");
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    this.setState({ dateEndSelectDraft: date });
  }}
  style={{
    padding: "6px",
    fontSize: "14px",
    border: "1px solid #ccc",
    borderRadius: "4px",
  }}
/>
          </Col>
          <Col>
  <label style={{ fontWeight: "bold", fontSize: "14px" }}>&nbsp;</label>
  <button
    className="btn btn-primary"
    onClick={this.handleSearchDateRange}
    disabled={this.state.loading}
    style={{ fontSize: "14px", padding: "6px 12px" }}
  >
    Buscar
  </button>
</Col>

          <Col>
            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Mostrar por:</label>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                className={`btn ${this.state.salesFilterType === 'salesAmount' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => this.setState({ salesFilterType: 'salesAmount' })}
                style={{ fontSize: '14px', padding: '6px 12px' }}
              >
                Pesos
              </button>
              <button
                className={`btn ${this.state.salesFilterType === 'salesQuantity' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => this.setState({ salesFilterType: 'salesQuantity' })}
                style={{ fontSize: '14px', padding: '6px 12px' }}
              >
                Piezas
              </button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col s={12}>
            {this.state.loading ? (
              <LoadingView />
            ) : this.state.dataSalesByCustomerType && this.state.dataSalesByCustomerType.length > 0 ? (
<TableF
  data={this.state.dataSalesByCustomerType}
  user={this.state.user}
  filterType={this.state.salesFilterType}
  realDays={this.state.realDays}
  potentialFactor={getPotentialFactorFromState(this.state)}
/>
            ) : (
              <p>No hay datos disponibles para el rango seleccionado.</p>
            )}
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default ModalIndicators;
